import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 152 90"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M108.622 90H0V0h152v51.79h-2.311V2.352H2.311v85.296h106.311z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M108.622 23.255H96.978v44.334h11.644z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M81.867 57.604H71.689c-5.155 0-9.333-4.172-9.333-9.32V23.21H50.71v28.27c0 8.875 7.2 16.02 16.045 16.02H93.51V23.21H81.867v34.393M127.2 23.255v18.55h-15.867v9.985H127.2v25.784h11.644v-54.32zM22.578 45.621v-.31c0-5.77 4.444-12.071 10.444-12.071h14.223v-9.941H32.178c-12.356 0-22.4 9.852-22.4 22.012v.31c0 12.116 10 21.968 22.355 21.968h16.311v-9.941h-15.51c-5.956 0-10.4-6.257-10.4-12.027z"
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "logo"}) } }